import React from 'react';
import { AssetMarker } from './AssetMarker';
import { Asset } from 'types/asset';

type AssetMarkersProps = {
  assets: Asset[];
};

function AssetMarkers({ assets }: AssetMarkersProps) {
  return (
    <>
      {assets.map((asset) => {
        return <AssetMarker key={asset.asset_id} asset={asset} />;
      })}
    </>
  );
}

export default AssetMarkers;
